
// src/web/components/diary-v2-progress-chart.js

import React from 'react';
import { themr } from 'react-css-themr'
import diaryKpiTheme from './themes/diary-kpi.css'

const style={
  container: {
    backggroundColor: '#FFF',
    borderColor: '#DDD',
    borderWidth: 0.5,
    padding: 5,
    margin: 3,
  }
}

@themr('DiaryKPI', diaryKpiTheme)
class DiaryV2ProgressChart extends React.Component {
  render() {
    const {
      t,
      theme,
      attach_json,
    } = this.props
    if (!attach_json)
      return null
  
    const {
      v2progress_chart
    } = attach_json
    if (!v2progress_chart)
      return null
  
    return (
      <div className={theme.kpi}>
        <h3 className={theme.title}>{v2progress_chart.name}</h3>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
          <div style={{ fontWeight: 'bold' }}>{v2progress_chart.performance}</div>
          <div style={{ }}>{v2progress_chart.goal}</div>
          <div style={{ }}>{v2progress_chart.percentage}</div>
        </div>
      </div>
    )
  }
}

export default DiaryV2ProgressChart



// WEBPACK FOOTER //
// ./src/web/components/diary-v2-progress-chart.jsx